import React, { createContext, useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from "firebase/auth";

import { db } from "../firebase";
import { query, where, collection, getDocs } from "firebase/firestore";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [currentUser, setCurrentUser] = useState(null);
  const [user, setUser] = useState(null);

  const auth = getAuth();

  const getUserInfo = async (user, uid) => {

      console.log('user uid');
      console.log(uid);

      const snap = await getDocs(query(collection(db, "admins"), where("user", "==", uid)));
      snap.forEach((doc) => {

          //console.log('user context');

          let temp = doc.data();
          if (true) {
            user.account = temp.account; // free business premium
            user.company = temp.company;
            user.first_name = temp.first_name;
			user.last_name = temp.last_name;
            user.phone = temp.phone;
            user.id = doc.id;

            //console.log('user='+user.id);

            setUser(Object.assign({}, user));
          }
      });
  }

  useEffect(() => {


    onAuthStateChanged(auth, (user) => {

      if (user) {

        const uid = user.uid;
        setCurrentUser(uid);
        setUser(user);

        getUserInfo(user, uid);

      } else {

        setCurrentUser(0);
        setUser(false);
      };
    });
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, user, setUser }}>
      {children}
    </AuthContext.Provider>
  );

};
